<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="part01_hd" role="doc-part">
<div class="partbox">
<h1 class="h1part" id="part01_hd"><span aria-label="page vi" id="page_vi" role="doc-pagebreak"><span aria-label="page vii" id="page_vii" role="doc-pagebreak">ACT ONE <span class="heading_break">LOST</span></span></span></h1>
<div class="inlinegroup"><img alt="" class="landscape_100" role="presentation" src="e9781665903363/images/common01.jpg"/></div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?00a80b48